import { IPreguntaEstadoDTO, PreguntaEstadoDTO } from "./PreguntaEstado.DTO";
import { Nilable } from "@shared/utils";

export interface IEncuestaEstadoDTO {
    id: number;
    questions: IPreguntaEstadoDTO[];
}

export class EncuestaEstadoDTO {
    public id = 0;
    public preguntas: PreguntaEstadoDTO[] = [];

    constructor(json: Nilable<Partial<IEncuestaEstadoDTO>> = null) {
        if (json != null) {
            this.cargarDTO(json);
        }
    }

    public cargarDTO(json: Partial<IEncuestaEstadoDTO>) {
        if (json.id != null) {
            this.id = json.id;
        }
        if (json.questions != null) {
            this.preguntas = json.questions.map(pregunta => new PreguntaEstadoDTO(pregunta));
        }
    }

    public toJSON(): IEncuestaEstadoDTO {
        return {
            id: this.id,
            questions: this.preguntas.map(pregunta => pregunta.toJSON())
        };
    }
}
